export default "__VITE_ASSET__9P4dzGbT__"